import { render, staticRenderFns } from "./DiscountCodes.vue?vue&type=template&id=08035c62&scoped=true"
import script from "./DiscountCodes.vue?vue&type=script&lang=js"
export * from "./DiscountCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08035c62",
  null
  
)

export default component.exports